module.exports = __webpack_public_path__ + "static/media/Level4.5b3abcca.png";